import { render } from "./EeaDefinitionIcon.vue?vue&type=template&id=4eea7c28&ts=true"
import script from "./EeaDefinitionIcon.vue?vue&type=script&lang=ts"
export * from "./EeaDefinitionIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__